<template>
    <div>
        <div id="slowPop" :class="slows?'animate':''" @touchmove.prevent v-if="slows">
            <div class="box">
                <div>邀请链接已复制</div>
                <div>快去分享给小伙伴吧</div>
                <img src="../assets/images/copy.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components:{

        },
        props:["slows"],
        data() {
            return {
                
            }
        },
        created() {
            // console.log(this.slows);
        },
        methods: {

        },
    }
</script>

<style lang="less" scoped>
    #slowPop{
        position:fixed;
        left:0;
        top:0;
        width:100%;
        height:100%;
        z-index:10;
        background:rgba(127,127,127,.5);
        opacity: 0;
        .box{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            background: #FFFFFF;
            border-radius: 10px;
            width: 200px;
            height: 120px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            div{
                font-size: 16px;
                font-weight: lighter;
                &:last-of-type{
                    margin: 6px 0 10px;
                }
            }
            img{
                width: 30px;
                height: 30px;
            }
        }

        
    }

    .animate{
        animation: opacity-1 2.5s linear;
        -webkit-animation: opacity-1 2.5s linear;
    }
    @keyframes opacity-1{
        0% {
            opacity: 0;
        }
        20% {
            opacity: 1;
        }
        70% {
            opacity: 1;
        }
        85% {
            opacity: 0.5;
        }
        100% {
            opacity: 0;
        }
    }
    @-webkit-keyframes opacity-1{
        0% {
            opacity: 0;
        }
        20% {
            opacity: 1;
        }
        70% {
            opacity: 1;
        }
        85% {
            opacity: 0.5;
        }
        100% {
            opacity: 0;
        }
    }

    

    .showBox{
        width: 120px;
        height: 50px;
        background: skyblue;
        color: #FFFFFF;
        text-align: center;
        line-height: 50px;
    }
</style>